import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";
import { withLoader } from "@/store/thunks/thunkWrappers";
import { addFileToHeliaThunk } from '@/store/thunks/poc/helia';

export const uploadFileThunk = createAppAsyncThunk(
  "sixDetail/uploadFile",
  withLoader(
    async(
      { sixId, file, uploadId: providedUploadId }: { sixId: string; file: File; uploadId?: string },
      { dispatch, getState }
    ) => {
      const uploadId = providedUploadId ?? crypto.randomUUID();
      const state = getState().sixDetail;
      const participants = state.participants;
      const normalizedFolderPath =
        state.currentFolderPath !== undefined && state.currentFolderPath !== '/'
          ? state.currentFolderPath.replace(/\/+$/, '')
          : '';
      const path = normalizedFolderPath.length > 0
        ? `${normalizedFolderPath}/${file.name}`
        : `/${file.name}`;

      const allParticipantIds = [
        ...(participants?.owners ?? []),
        ...(participants?.internalParticipants ?? []),
        ...(participants?.externalParticipants ?? []),
      ].map((participant) => participant.id);

      const result = await dispatch(
        addFileToHeliaThunk({
          sixId,
          allParticipantIds,
          file,
          path,
          uploadId,
        })
      ).unwrap();

      return { uploadId: result.uploadId };
    }
  )
);
